import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { ForeclosureRequestStore } from '../stores/foreclosureRequestStore';

export const useForeclosureRequestStore = () =>
  useContext<{
    foreclosureRequestStore: ForeclosureRequestStore;
  }>(StoreContext);